import React, { useState, useEffect } from 'react';
import { Card, Spinner, Badge, Table, Alert, Button, Modal, Row, Col, Accordion, ListGroup, Container } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { API_URL } from "../../utils/constant";
import Pagination from "../Pagination/Pagination";
import axios from 'axios';
import {
    faSearch, faSync, faExternalLinkAlt, faTools,
    faShieldAlt, faNetworkWired, faGlobe, faLink
} from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
const modalStyles = {
    modal90w: {
        maxWidth: '90%',
        width: '1200px'
    },
    groupDetails: {
        maxHeight: '80vh',
        overflowY: 'auto'
    }
};


const DEBUG_COMPONENTS = {
    Modal, Button, Spinner, Badge, Table, Alert, Accordion, ListGroup
};

const RansomwareTracker = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [victims, setVictims] = useState([]);
    const [filteredVictims, setFilteredVictims] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [selectedVictim, setSelectedVictim] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [selectedGroup, setSelectedGroup] = useState(null);
    const [showGroupModal, setShowGroupModal] = useState(false);
    const [groupDetails, setGroupDetails] = useState(null);
    const [groupLoading, setGroupLoading] = useState(false);
    const [searchFilters, setSearchFilters] = useState({
        keyword: '',
        country: '',
        sector: '',
        dateFrom: '',
        dateTo: ''
    });
    const [filterOptions, setFilterOptions] = useState({
        countries: [],
        activities: []
    });
    const [filtersLoading, setFiltersLoading] = useState(false);
    const [appliedFilters, setAppliedFilters] = useState({
        keyword: '',
        country: '',
        sector: '',
        dateFrom: '',
        dateTo: ''
    });
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [totalItems, setTotalItems] = useState(0);
    const [summaryStats, setSummaryStats] = useState({
        activeGroups: null,
        affectedCountries: null,
        affectedSectors: null
    });
    const fetchVictims = async (filters = appliedFilters) => {
        setLoading(true);
        try {
            let url = `${API_URL}/threat-intel/ransomware/cyberattacks`;

            // Prepare params object for axios
            // Normalize country to uppercase to match API expectations
            const normalizedFilters = {
                ...filters,
                country: filters?.country ? filters.country.trim().toUpperCase() : ''
            };

            const params = {
                page: currentPage,
                limit: itemsPerPage,
                ...(normalizedFilters?.keyword ? { keyword: normalizedFilters.keyword } : {}),
                ...(normalizedFilters?.country ? { countryCode: normalizedFilters.country } : {}),
                ...(normalizedFilters?.sector ? { sector: normalizedFilters.sector } : {}),
                ...(normalizedFilters?.dateFrom ? { dateFrom: normalizedFilters.dateFrom } : {}),
                ...(normalizedFilters?.dateTo ? { dateTo: normalizedFilters.dateTo } : {})
            };

            const response = await axios.get(url, {
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('session')}`,
                    'Content-Type': 'application/json'
                },
                params
            });

            
            if (response.data.error) {
                throw new Error(response.data.userMessage);
            }

            const apiData = response.data.data;
            setVictims(apiData.cyberattacks);
            setFilteredVictims(apiData.cyberattacks);
            setTotalItems(apiData.total);
            setSummaryStats({
                activeGroups: apiData.activeGroups ?? null,
                affectedCountries: apiData.affectedCountries ?? null,
                affectedSectors: apiData.affectedSectors ?? null
            });
        } catch (err) {
            setError(err.message || 'An error occurred while fetching data');
            // console.error removed
        } finally {
            setLoading(false);
        }
    };

    const fetchFilterOptions = async () => {
        setFiltersLoading(true);
        try {
            const response = await axios.get(
                `${API_URL}/threat-intel/ransomware/countries-activities`,
                {
                    headers: {
                        'Authorization': `Bearer ${localStorage.getItem('session')}`,
                        'Content-Type': 'application/json'
                    }
                }
            );


            if (response.data.error) {
                throw new Error(response.data.userMessage);
            }

            const apiData = response.data.data || {};
            const countries = Array.from(new Set(
                (apiData.countries || [])
                    .map(code => (code || '').trim().toUpperCase())
                    .filter(Boolean)
            )).sort();

            const activities = Array.from(new Set(
                (apiData.activities || [])
                    .map(activity => (activity || '').trim())
                    .filter(Boolean)
            )).sort((a, b) => a.localeCompare(b));

            setFilterOptions({
                countries,
                activities
            });
        } catch (err) {
            setError(err.message || 'An error occurred while fetching filter options');
        } finally {
            setFiltersLoading(false);
        }
    };

    useEffect(() => {
        fetchVictims(appliedFilters);
    }, [currentPage, itemsPerPage, appliedFilters]);

    useEffect(() => {
        fetchFilterOptions();
    }, []);

    useEffect(() => {
        const filtered = victims.filter(victim =>
            victim.victim.toLowerCase().includes(searchTerm.toLowerCase()) ||
            victim.group.toLowerCase().includes(searchTerm.toLowerCase()) ||
            (victim.country && victim.country.toLowerCase().includes(searchTerm.toLowerCase())) ||
            (victim.activity && victim.activity.toLowerCase().includes(searchTerm.toLowerCase()))
        );
        setFilteredVictims(filtered);
    }, [searchTerm, victims]);

    const handleShowDetails = (victim) => {
        setSelectedVictim(victim);
        setShowModal(true);
    };

    const renderDetailsModal = () => {
        if (!selectedVictim) return null;

        return (
            <Modal
                show={showModal}
                onHide={() => setShowModal(false)}
                size="lg"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>{selectedVictim.victim}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="mb-3">
                        <h6>Description:</h6>
                        <p>{selectedVictim.description || 'No description available'}</p>
                    </div>

                    {selectedVictim.claim_url && (
                        <div className="mb-3">
                            <h6>Claim URL:</h6>
                            <a
                                href={selectedVictim.claim_url}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-break"
                            >
                                {selectedVictim.claim_url}
                            </a>
                        </div>
                    )}

                    {selectedVictim.darkweb_url && (
                        <div className="mb-3">
                            <h6>Dark Web Link:</h6>
                            <code className="text-break">{selectedVictim.darkweb_url}</code>
                        </div>
                    )}

                    {selectedVictim.screenshot && (
                        <div className="mb-3">
                            <h6>Screenshot:</h6>
                            <img
                                src={selectedVictim.screenshot}
                                alt="Attack Screenshot"
                                className="img-fluid rounded"
                                style={{ maxHeight: '400px' }}
                            />
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" className='btn btn-round btn-default' onClick={() => setShowModal(false)}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    };

    const getStats = () => {
        const stats = {
            totalVictims: victims.length,
            byGroup: {},
            byCountry: {},
            bySector: {}
        };

        victims.forEach(victim => {
            stats.byGroup[victim.group] = (stats.byGroup[victim.group] || 0) + 1;

            if (victim.country) {
                stats.byCountry[victim.country] = (stats.byCountry[victim.country] || 0) + 1;
            }

            if (victim.activity) {
                stats.bySector[victim.activity] = (stats.bySector[victim.activity] || 0) + 1;
            }
        });

        return stats;
    };

    const getCountryFlag = (countryCode) => {
        if (!countryCode) return '';
        const OFFSET = 127397;
        const chars = [...countryCode.toUpperCase()].map(char =>
            String.fromCodePoint(char.charCodeAt(0) + OFFSET)
        );
        return chars.join('');
    };

    const fetchGroupDetails = async (groupName) => {
        setGroupLoading(true);
        try {
            const response = await axios.get(
                `${API_URL}/threat-intel/ransomware/groups`,
                {
                    headers: {
                        'Authorization': `Bearer ${localStorage.getItem('session')}`,
                        'Content-Type': 'application/json'
                    },
                    params: {
                        groupNameQuery: groupName
                    }
                }
            );


            if (response.data.error) {
                throw new Error(response.data.userMessage);
            }

            setGroupDetails(response.data);
            setShowGroupModal(true);
        } catch (err) {
            // console.error removed
            setError(err.message || 'An error occurred while fetching group details');
        } finally {
            setGroupLoading(false);
        }
    };

    const renderGroupModal = () => {

        return (
            <Modal
                show={showGroupModal}
                onHide={() => setShowGroupModal(false)}
                size="lg"
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        Group Details
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {groupLoading ? (
                        <div className="text-center">
                            <Spinner animation="border" />
                        </div>
                    ) : (
                        <div>
                            {groupDetails?.data?.groups?.[0] ? (
                                <div>
                                    <h5>{groupDetails.data.groups[0].name}</h5>
                                    <p>{groupDetails.data.groups[0].description}</p>
                                </div>
                            ) : (
                                <Alert variant="warning">
                                    No group details available
                                </Alert>
                            )}
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        variant="secondary"
                        onClick={() => setShowGroupModal(false)}
                    >
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    };

    const renderVictimsTable = () => {
        if (!filteredVictims || filteredVictims.length === 0) {
            return (
                <Alert variant="info">
                    No ransomware victims found matching your search.
                </Alert>
            );
        }

        return (
            <div className="table-responsive">
                <table className="table table-custom spacing5 mb-0">
                    <thead>
                        <tr>
                            <th>Victim</th>
                            <th>Group</th>
                            <th>Country</th>
                            <th>Sector</th>
                            <th>Attack Date</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredVictims.map((victim, index) => (
                            <tr key={index}>
                                <td>
                                    {victim.victim}
                                    {victim.domain && (
                                        <small className="text-muted d-block">
                                            {victim.domain}
                                        </small>
                                    )}
                                </td>
                                <td>
                                    <Badge
                                        bg="secondary"
                                        style={{ cursor: 'pointer' }}
                                        onClick={() => {
                                            fetchGroupDetails(victim.group);
                                        }}
                                    >
                                        {victim.group}
                                    </Badge>
                                </td>
                                <td>
                                    <div className="d-flex align-items-center">
                                        {victim.country && (
                                            <span className="me-2" style={{ fontSize: '1.2em' }}>
                                                {getCountryFlag(victim.country)}
                                            </span>
                                        )}
                                        {victim.country || 'N/A'}
                                    </div>
                                </td>
                                <td>{victim.activity || 'N/A'}</td>
                                <td>
                                    {victim.attackdate ?
                                        new Date(victim.attackdate).toLocaleDateString() :
                                        'N/A'
                                    }
                                </td>
                                <td>
                                    <div className="d-flex gap-2">
                                        {(victim.description || victim.screenshot || victim.darkweb_url) && (
                                            <Link
                                                to="#"
                                                onClick={() => handleShowDetails(victim)}
                                            >
                                                <FontAwesomeIcon icon={faSearch} className='mr-2' /> Details
                                            </Link>
                                        )}
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        );
    };

    const renderStats = () => {
        const computed = getStats();
        const stats = {
            activeGroups: summaryStats.activeGroups ?? Object.keys(computed.byGroup).length,
            affectedCountries: summaryStats.affectedCountries ?? Object.keys(computed.byCountry).length,
            affectedSectors: summaryStats.affectedSectors ?? Object.keys(computed.bySector).length
        };

        return (
            <div className="mb-4">
                <div className="row g-3">
                    <div className="col-md-4">
                        <Card className="h-100">
                            <Card.Body>
                                <h6>Active Groups</h6>
                                <h3>{stats.activeGroups}</h3>
                            </Card.Body>
                        </Card>
                    </div>
                    <div className="col-md-4">
                        <Card className="h-100">
                            <Card.Body>
                                <h6>Affected Countries</h6>
                                <h3>{stats.affectedCountries}</h3>
                            </Card.Body>
                        </Card>
                    </div>
                    <div className="col-md-4">
                        <Card className="h-100">
                            <Card.Body>
                                <h6>Affected Sectors</h6>
                                <h3>{stats.affectedSectors}</h3>
                            </Card.Body>
                        </Card>
                    </div>
                </div>
            </div>
        );
    };

    // Handle search form submission
    const handleSearch = (e) => {
        e.preventDefault();
        // Normalize country to uppercase before applying filters
        const normalizedFilters = {
            ...searchFilters,
            country: searchFilters.country ? searchFilters.country.trim().toUpperCase() : ''
        };
        setAppliedFilters(normalizedFilters);
        setCurrentPage(1);
    };

    // Reset search filters
    const handleReset = () => {
        const reset = {
            keyword: '',
            country: '',
            sector: '',
            dateFrom: '',
            dateTo: ''
        };
        setSearchFilters(reset);
        setAppliedFilters(reset);
        setCurrentPage(1);
    };

    // Test function to open modal
    const handleTestModal = () => {
        setGroupDetails({
            data: {
                groups: [{
                    name: 'Test Group',
                    description: 'Test Description'
                }]
            }
        });
        setShowGroupModal(true);
    };

    return (
        <Container fluid className="mt-4">
            <Card>
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <h4 className="welcome-text">Recent Ransomware Attacks</h4>
                    <Button
                        variant="outline-primary"
                        size="sm"
                        onClick={() => fetchVictims(appliedFilters)}
                        disabled={loading}
                    >
                        <FontAwesomeIcon icon={faSync} spin={loading} /> Refresh
                    </Button>
                </div>
                <form onSubmit={handleSearch} className="mt-3 mb-3">
                    <div className="row g-3 mb-3">
                        <div className="col-md-4">
                        <div
                            className="searchBoxInput p-0"
                          >
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Search keyword..."
                                value={searchFilters.keyword}
                                onChange={(e) => setSearchFilters({
                                    ...searchFilters,
                                    keyword: e.target.value
                                })}
                            />
                            </div>
                        </div>
                        <div className="col-md-2">
                            <select
                                className="form-control"
                                value={searchFilters.country}
                                onChange={(e) => {
                                    const selectedCountry = e.target.value;
                                    const updatedSearchFilters = {
                                        ...searchFilters,
                                        country: selectedCountry
                                    };
                                    setSearchFilters(updatedSearchFilters);
                                    
                                    // Auto-apply filter when country changes
                                    const normalizedCountry = selectedCountry ? selectedCountry.trim().toUpperCase() : '';
                                    const updatedAppliedFilters = {
                                        ...searchFilters,
                                        country: normalizedCountry
                                    };
                                    setAppliedFilters(updatedAppliedFilters);
                                    setCurrentPage(1);
                                }}
                                disabled={filtersLoading}
                            >
                                <option value="">All Countries</option>
                                {filterOptions.countries.map((country) => (
                                    <option key={country} value={country}>
                                        {country}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div className="col-md-2">
                            <select
                                className="form-control"
                                value={searchFilters.sector}
                                onChange={(e) => {
                                    const selectedSector = e.target.value;
                                    const updatedSearchFilters = {
                                        ...searchFilters,
                                        sector: selectedSector
                                    };
                                    setSearchFilters(updatedSearchFilters);
                                    
                                    // Auto-apply filter when sector changes
                                    const updatedAppliedFilters = {
                                        ...searchFilters,
                                        sector: selectedSector
                                    };
                                    setAppliedFilters(updatedAppliedFilters);
                                    setCurrentPage(1);
                                }}
                                disabled={filtersLoading}
                            >
                                <option value="">All Sectors</option>
                                {filterOptions.activities.map((activity) => (
                                    <option key={activity} value={activity}>
                                        {activity}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div className="col-md-2">
                            <input
                                type="date"
                                className="form-control"
                                value={searchFilters.dateFrom}
                                onChange={(e) => setSearchFilters({
                                    ...searchFilters,
                                    dateFrom: e.target.value
                                })}
                            />
                        </div>
                        <div className="col-md-2">
                            <input
                                type="date"
                                className="form-control"
                                value={searchFilters.dateTo}
                                onChange={(e) => setSearchFilters({
                                    ...searchFilters,
                                    dateTo: e.target.value
                                })}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <div className="d-flex gap-2">
                                <Button
                                    type="submit"
                                    variant="primary"
                                    disabled={loading}
                                >
                                    <FontAwesomeIcon icon={faSearch} /> Search
                                </Button>
                                <Button
                                    type="button"
                                    variant="secondary"
                                    onClick={handleReset}
                                    disabled={loading}
                                >
                                    Reset
                                </Button>
                            </div>
                        </div>
                    </div>
                </form>
                <Card.Body>
                    {loading && (
                        <div className="text-center p-4">
                            <Spinner animation="border" />
                        </div>
                    )}

                    {/* {error && (
                        <Alert variant="danger">{error}</Alert>
                    )} */}

                    {/* {!loading && !error && ( */}
                        {/* <> */}
                            {renderStats()}
                            {renderVictimsTable()}
                            <div className="d-flex justify-content-between align-content-center mt-3">
                                <div className="dataTables_paginate">
                                    {totalItems > 10 && (
                                        <Pagination
                                            className="pagination-bar"
                                            currentPage={currentPage}
                                            totalCount={totalItems}
                                            pageSize={itemsPerPage}
                                            onPageChange={(page) => {
                                                setCurrentPage(page);
                                            }}
                                        />
                                     )}
                                </div>
                                {totalItems > 10 && (
                                    <select
                                        value={itemsPerPage}
                                        onChange={(e) => {
                                            setItemsPerPage(Number(e.target.value));
                                            setCurrentPage(1);
                                        }}
                                        className="form-control limitSelectBox"
                                    >
                                        <option value={10}>10 per page</option>
                                        <option value={25}>25 per page</option>
                                        <option value={50}>50 per page</option>
                                        <option value={100}>100 per page</option>
                                    </select>
                                )}
                            </div>
                        {/* </>
                    )} */}
                </Card.Body>
            </Card>
            {renderDetailsModal()}
            {renderGroupModal()}
            <style>
                {` 
                    .modal-90w {
                        max-width: 90%;
                        width: 1200px;
                    }
                `}
            </style>
            {/* Test button */}
            {/* <Button onClick={handleTestModal}>
                Test Modal
            </Button> */}
        </Container>
    );
};

export default RansomwareTracker; 